webpackJsonp([0,50],{

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dealers_list_vue__ = __webpack_require__(850);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06522c49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dealers_list_vue__ = __webpack_require__(1067);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dealers_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06522c49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dealers_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1"},[_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"dealers","columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.fullName)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.email)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.phone)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.numDocument)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.country.data.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_c('app-tooltip-button',{attrs:{"color":"blue","icon":"swap_horiz","text":"Recursos"},on:{"click-icon":function($event){_vm.goToResource(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"highlight","text":"Proyectos"},on:{"click-icon":function($event){_vm.goToProjects(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"router","text":"Aplicaciones"},on:{"click-icon":function($event){_vm.goToApplications(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"web","text":"Template"},on:{"click-icon":function($event){_vm.goToTemplate(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"perm_identity","text":"Implementadores"},on:{"click-icon":function($event){_vm.goToImplementers(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar App"},on:{"click-icon":function($event){_vm.goToDeatil(props.row.id)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar"},on:{"click-icon":function($event){_vm.openDialog(props.row)}}})],1)]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.dialogMessage))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"green","dark":""},nativeOn:{"click":function($event){return _vm.deleteDealers($event)}}},[_vm._v("\n\t\t\t\t\tSI\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action",attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n\t\t\t\t\tNO\n\t\t\t\t")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_implementers_list_vue__ = __webpack_require__(851);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243d1d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_implementers_list_vue__ = __webpack_require__(1069);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_implementers_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243d1d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_implementers_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"implementers-list"},[_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"implementers","columns":_vm.columns,"rows":_vm.rowsImplementers,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.fullName)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.email)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.phone)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.distributor.data.name)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.country.data.name)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',[_c('app-tooltip-button',{attrs:{"color":"blue","icon":"location_city","text":"Empresa"},on:{"click-icon":function($event){_vm.goToCompany(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar"},on:{"click-icon":function($event){_vm.goToDeatil(props.row.id)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar App"},on:{"click-icon":function($event){_vm.openDialog(props.row)}}})],1)]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.dialogMessage))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"green","dark":""},nativeOn:{"click":function($event){return _vm.deleteImplementers($event)}}},[_vm._v("\n\t\t\t\t\t\tSI\n\t\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action",attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n\t\t\t\t\t\tNO\n\t\t\t\t\t")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"px-4 mt-3 content-tabs-configuration"},[_c('v-flex',[_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","background-color":"transparent"},slot:"extension",model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t")])}))],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('dealers-list')],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('implementers-list')],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('synchronize-companies-list')],1)],1)],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_synchronize_companies_list_vue__ = __webpack_require__(743);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06afcacc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_synchronize_companies_list_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06afcacc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_synchronize_companies_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06afcacc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_synchronize_companies_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(578);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(156);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(579), __esModule: true };

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(74);
module.exports = __webpack_require__(580);


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(76);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(10).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_app_tooltip_button__ = __webpack_require__(150);






var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						delete this.params.perPage;
						this.params.page = this.currentPage;
						_context.prev = 2;
						_context.next = 5;
						return this.$httpCompany.get('ext-companies', { params: this.params });

					case 5:
						response = _context.sent;

						this.lastPage = Number(response.headers['x-last-page']);
						this.itemsTotalQuantity = Number(response.headers['x-quantity']);
						this.rowsCompany = response.data.map(function (r) {
							// const typeProcess = this.process.find((p) => p.id === r.processId);
							var _r$nombreSocial$split = r.nombreSocial.split(' - ', 5),
							    _r$nombreSocial$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_r$nombreSocial$split, 5),
							    ruc = _r$nombreSocial$split2[0],
							    cliente = _r$nombreSocial$split2[1],
							    phone = _r$nombreSocial$split2[2],
							    implementa = _r$nombreSocial$split2[3],
							    phoneImple = _r$nombreSocial$split2[4];

							var newR = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r);
							newR.dateBlocked = r.dateBlocked ? r.dateBlocked.split('T')[0] : '-';
							newR.convertedAt = r.convertedAt ? new Date(r.convertedAt).toISOString().split('T')[0] : '-';
							newR.ruc = ruc;
							newR.cliente = cliente || implementa;
							newR.phone = phone || phoneImple || '-';
							return newR;
						});
						_context.next = 14;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 11]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var retryProcess = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(log) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.isRetrying = true;
						_context2.prev = 1;
						_context2.next = 4;
						return this.$httpCompany.patch('ext-companies/' + this.selectedCompanyId + '/process', { processId: log.processId });

					case 4:
						this.showNotification('Se solicitó el reintento correctamente', 'success');
						this.loadData();
						this.isRetrying = false;
						this.closeLogsDialog();
						_context2.next = 14;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](1);

						this.showError();
						this.isRetrying = false;

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 10]]);
	}));

	return function retryProcess(_x) {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
	if (this.$route.name === 'synchronize-companies-list') {
		this.columns[15].checked = false;
		this.columns[15].visible = false;
		this.columns[15].flagVisible = true;
	}
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function data() {
	return {
		columns: [{ id: 1, name: '#Compañia', value: 'numberCompany', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Correo', value: 'email', checked: false, visible: false }, { id: 4, name: 'Teléfono', value: 'phone', checked: true, visible: true }, { id: 5, name: '#Pedido', value: 'numberOrder', checked: true, visible: true }, { id: 6, name: 'Empleado', value: 'employeeName', checked: true, visible: true }, { id: 7, name: 'IdVenda', value: 'idsale', checked: true, visible: true }, { id: 8, name: 'Dominio', value: 'domain', checked: false, visible: false }, { id: 9, name: 'AclCompañia', value: 'aclCompany', checked: true, visible: true }, { id: 10, name: 'Proceso', value: 'processId', checked: true, visible: true }, { id: 11, name: 'País', value: 'country', checked: false, visible: false }, { id: 12, name: 'Plan', value: 'plan', checked: true, visible: true }, { id: 13, name: 'Estado', value: 'estatus', checked: true, visible: true }, { id: 14, name: 'Fecha de bloqueo', value: 'dateBlocked', checked: true, visible: true }, { id: 15, name: 'Fecha de creación', value: 'dateCreated', checked: true, visible: true }, { id: 16, name: 'Acciones', value: 'action', checked: true, visible: true }],
		process: [{ id: 1, name: 'Compañia registrada' }, { id: 2, name: 'Usuario registrado' }, { id: 3, name: 'Registrado en notion' }, { id: 4, name: 'Registrado en cliente del notion' }, { id: 5, name: 'Notificación al usuario' }, { id: 6, name: 'Proceso de bloqueo' }],
		checkAll: false,
		status: [{
			id: 1,
			name: 'Registrado'
		}, {
			id: 2,
			name: 'Pendiente'
		}, {
			id: 3,
			name: 'Iniciado'
		}, {
			id: 4,
			name: 'Finalizado'
		}, {
			id: 5,
			name: 'Error'
		}],
		currentPage: 1,
		lastPage: 1,
		itemsTotalQuantity: 0,
		params: {
			status: null,
			page: 1,
			search: null,
			limit: 30,
			sortDirection: 'desc',
			sortField: 'created_at'
		},
		rows: [],
		rowsCompany: [],
		isClearing: false,
		logsDialog: false,
		selectedLogs: [],
		selectedCompanyId: null,
		isRetrying: false
	};
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

function goEdit(row) {
	var query = { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row) };
	this.goTo('page-config-edit-synchronize', { query: query });
}

function openLogsDialog(row) {
	this.selectedLogs = row.logs;
	this.selectedCompanyId = row.id;
	this.logsDialog = true;
}

function closeLogsDialog() {
	if (this.isRetrying) {
		return;
	}
	this.logsDialog = false;
	this.selectedLogs = [];
	this.selectedCompanyId = null;
}

function getProcessName(processId) {
	var process = this.process.find(function (p) {
		return p.id === processId;
	});
	return process ? process.name : 'Proceso desconocido';
}

function newRoute(newValue) {
	if (newValue.name === 'page-config-synchronize-companies') {
		this.loadData();
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'synchronize-companies-list',
	created: created,
	data: data,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_5__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		changePage: changePage,
		loadData: loadData,
		goEdit: goEdit,
		onSearch: onSearch,
		openLogsDialog: openLogsDialog,
		closeLogsDialog: closeLogsDialog,
		getProcessName: getProcessName,
		retryProcess: retryProcess,
		changeStatus: function changeStatus(state) {
			this.params.status = state;
			this.loadData();
		}
	},
	watch: {
		$route: newRoute
	}
});

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(756);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("5321d5b6", content, true);

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.logs-dialog-content[data-v-06afcacc]{max-height:400px;overflow-y:auto}.log-item[data-v-06afcacc]{background:#f1f3f7;border-left:4px solid #f52c18;border-radius:2px;margin-bottom:10px;padding:8px 12px}.log-item[data-v-06afcacc]:last-child{margin-bottom:0}.log-item-header[data-v-06afcacc]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:4px}.log-item-process[data-v-06afcacc]{color:#4a4a4a;font-family:Opens_bold}.log-item-code[data-v-06afcacc]{color:#4a4a4a;display:block;font-size:11px;margin-bottom:4px}.log-item-error[data-v-06afcacc]{color:#f52c18;font-size:13px;word-break:break-word}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration/synchronize-companies-list.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,sCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,2BACE,mBAAoB,AACpB,8BAA+B,AAC/B,kBAAmB,AACnB,mBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACI,eAAmB,CACtB,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,iBAAmB,CACpB,AACD,mCACE,cAAe,AACf,sBAA0B,CAC3B,AACD,gCACE,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AACD,iCACE,cAAe,AACf,eAAgB,AAChB,qBAAuB,CACxB","file":"synchronize-companies-list.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.logs-dialog-content[data-v-06afcacc] {\n  max-height: 400px;\n  overflow-y: auto;\n}\n.log-item[data-v-06afcacc] {\n  background: #f1f3f7;\n  border-left: 4px solid #f52c18;\n  border-radius: 2px;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n}\n.log-item[data-v-06afcacc]:last-child {\n    margin-bottom: 0px;\n}\n.log-item-header[data-v-06afcacc] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 4px;\n}\n.log-item-process[data-v-06afcacc] {\n  color: #4a4a4a;\n  font-family: \"Opens_bold\";\n}\n.log-item-code[data-v-06afcacc] {\n  color: #4a4a4a;\n  display: block;\n  font-size: 11px;\n  margin-bottom: 4px;\n}\n.log-item-error[data-v-06afcacc] {\n  color: #f52c18;\n  font-size: 13px;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"synchronize-companies-list"},[_c('v-flex',{attrs:{"ma-4":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-layout',{attrs:{"xs2":"","mb-4":"","align-center":""}},[_c('v-select',{staticClass:"body-1 mt-2",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","label":"Estado","items":_vm.status,"append-icon":"close"},on:{"input":_vm.changeStatus,"click:append":function($event){_vm.changeStatus(null)}},model:{value:(_vm.params.status),callback:function ($$v) {_vm.$set(_vm.params, "status", $$v)},expression:"params.status"}})],1)],1),_vm._v(" "),_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"synchronize-companies","columns":_vm.columns,"rows":_vm.rowsCompany,"items-quantity":_vm.rowsCompany.length,"items-total-quantity":_vm.itemsTotalQuantity,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.ruc)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.razSoc)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.email || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.phone)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.orderNumber || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.employeeName || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 7)),expression:"showRow(columns, 7)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.salesId || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 8)),expression:"showRow(columns, 8)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.domain || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 9)),expression:"showRow(columns, 9)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.companyId || '-')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 10)),expression:"showRow(columns, 10)"}]},[_c('span',{style:({ color: props.row.processName.color, textShadow: '0.5px 0.5px 0 ' + props.row.processName.color})},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.processName.name)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 11)),expression:"showRow(columns, 11)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.country.name)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 12)),expression:"showRow(columns, 12)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.planCode)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 13)),expression:"showRow(columns, 13)"}]},[_c('span',{style:({ color: props.row.statusName.color, textShadow: '0.5px 0.5px 0 ' + props.row.statusName.color})},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.statusName.name)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 14)),expression:"showRow(columns, 14)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.dateBlocked)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 15)),expression:"showRow(columns, 15)"}]},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.convertedAt)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 16)),expression:"showRow(columns, 16)"}]},[_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar"},on:{"click-icon":function($event){_vm.goEdit(props.row)}}}),_vm._v(" "),(props.row.logs && props.row.logs.length > 1)?_c('app-tooltip-button',{attrs:{"color":"red","icon":"history","text":"Ver logs"},on:{"click-icon":function($event){_vm.openLogsDialog(props.row)}}}):_vm._e()],1)]}}])})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600","persistent":_vm.isRetrying},model:{value:(_vm.logsDialog),callback:function ($$v) {_vm.logsDialog=$$v},expression:"logsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v("Registros de Errores")]),_vm._v(" "),_c('v-card-text',{staticClass:"logs-dialog-content"},_vm._l((_vm.selectedLogs),function(log,index){return _c('div',{key:index,staticClass:"log-item"},[_c('div',{staticClass:"log-item-header"},[_c('span',{staticClass:"log-item-process"},[_vm._v("Proceso: "+_vm._s(_vm.getProcessName(log.processId)))]),_vm._v(" "),(log.processId === 3 || log.processId === 4)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"btn-action caption ma-0",attrs:{"slot":"activator","color":"orange","dark":"","small":"","loading":_vm.isRetrying,"disabled":_vm.isRetrying},nativeOn:{"click":function($event){_vm.retryProcess(log)}},slot:"activator"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("sync")]),_vm._v("\n\t\t\t\t\t\t\t\tReintentar\n\t\t\t\t\t\t\t")],1),_vm._v(" "),_c('span',[_vm._v("Reintentar sincronización")])],1):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"log-item-code"},[_vm._v("Código: "+_vm._s(log.codeResponse))]),_vm._v(" "),_c('p',{staticClass:"log-item-error mb-0"},[_c('strong',[_vm._v("Error:")]),_vm._v(" "+_vm._s(log.bodyResponse)+"\n\t\t\t\t\t")])])})),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"primary","dark":"","disabled":_vm.isRetrying},nativeOn:{"click":function($event){return _vm.closeLogsDialog($event)}}},[_vm._v("\n\t\t\t\t\tCerrar\n\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuration_dealers_list__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuration_implementers_list__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_configuration_synchronize_companies_list__ = __webpack_require__(492);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function created() {
	if (this.$route.name === 'page-config-implementers') {
		this.tabsModel = 1;
	} else if (this.$route.name === 'page-config-dealers') {
		this.tabsModel = 0;
	} else if (this.$route.name === 'page-config-synchronize-companies') {
		this.tabsModel = 2;
	}
}

function tabsModel(value) {
	if (this.$route.meta.primary) {
		if (value === 0) {
			this.goTo('page-config-dealers');
		} else if (value === 1) {
			this.goTo('page-config-implementers');
		} else if (value === 2) {
			this.goTo('page-config-synchronize-companies');
		}
	}
}

function newRoute(value) {
	if (value.name === 'page-config-dealers') {
		this.tabsModel = 0;
	} else if (value.name === 'page-config-implementers') {
		this.tabsModel = 1;
	} else if (value.name === 'page-config-synchronize-companies') {
		this.tabsModel = 2;
	}
}

function data() {
	return {
		tabsModel: null,
		tabs: [{
			id: 1,
			name: 'Distribuidores'
		}, {
			id: 2,
			name: 'Implementadores'
		}, {
			id: 3,
			name: 'Sincronización de compañías'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-list-configuration',
	data: data,
	created: created,
	components: {
		dealersList: __WEBPACK_IMPORTED_MODULE_0__components_configuration_dealers_list__["a" /* default */],
		implementersList: __WEBPACK_IMPORTED_MODULE_1__components_configuration_implementers_list__["a" /* default */],
		synchronizeCompaniesList: __WEBPACK_IMPORTED_MODULE_2__components_configuration_synchronize_companies_list__["default"]
	},
	watch: {
		tabsModel: tabsModel,
		$route: newRoute
	}
});

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);



var loadData = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.params.page = this.currentPage;
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('distributaries', { params: this.params });

					case 4:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function loadData() {
		return _ref6.apply(this, arguments);
	};
}();

var deleteDealers = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return this.$http.delete('distributaries/' + this.idDelete);

					case 3:
						this.showNotification('Se eliminó correctamente');
						this.closeDialog();
						this.loadData();
						_context2.next = 11;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](0);

						if (_context2.t0.status === 405) {
							if (_context2.t0.data.message === 'USER_HAS_ASSOCIATED_DATA') {
								this.showError('Tiene datos asociados');
							}
						} else {
							this.showError();
						}

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 8]]);
	}));

	return function deleteDealers() {
		return _ref7.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

function goToProjects(_ref) {
	var name = _ref.name,
	    id = _ref.id;

	var parsedName = name.split(' ').join('-');
	this.goTo('page-dealers-projects', { params: { name: parsedName, id: id } });
}

function goToTemplate(_ref2) {
	var id = _ref2.id;

	this.goTo('page-config-template', { params: { id: id } });
}

function goToImplementers(_ref3) {
	var id = _ref3.id;

	this.goTo('page-dealers-implementers', { params: { id: id } });
}

function goToResource(_ref4) {
	var id = _ref4.id;

	this.goTo('page-dealers-resource', { params: { id: id } });
}

function goToApplications(_ref5) {
	var id = _ref5.id;

	this.goTo('page-dealers-application', { params: { id: id } });
}

function goToDeatil(id) {
	this.goTo('page-dealers-new', { params: { id: id } });
}

function newRoute(newValue, afterValue) {
	if (newValue.name === 'page-config-dealers' && afterValue.name === 'page-dealers-new') {
		this.loadData();
	}
}

function openDialog(item) {
	this.dialogMessage = '\xBFDesea eliminar de la lista a \'' + item.name + '\'?';
	this.idDelete = item.id;
	this.dialog = true;
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.idDelete = null;
}

function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Correo', value: 'email', checked: true, visible: true }, { id: 3, name: 'Teléfono', value: 'phone', checked: true, visible: true }, { id: 4, name: '#Compañia', value: 'company', checked: true, visible: true }, { id: 5, name: 'País', value: 'country', checked: true, visible: true }, { id: 6, name: 'Acciones', value: 'actions', checked: true, visible: true }],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		params: {
			page: 1
		},
		dialog: false,
		dialogMessage: '',
		idDelete: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dealers-list',
	data: data,
	created: created,
	methods: {
		closeDialog: closeDialog,
		changePage: changePage,
		deleteDealers: deleteDealers,
		onSearch: onSearch,
		goToApplications: goToApplications,
		goToImplementers: goToImplementers,
		goToProjects: goToProjects,
		goToResource: goToResource,
		goToTemplate: goToTemplate,
		loadData: loadData,
		goToDeatil: goToDeatil,
		openDialog: openDialog
	},
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	watch: {
		$route: newRoute
	}
});

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.params.page = this.currentPage;
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('implementers', { params: this.params });

					case 4:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var deleteImplementers = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return this.$http.delete('implementers/' + this.idDelete);

					case 3:
						this.showNotification('Se eliminó correctamente');
						this.closeDialog();
						this.listImplementers();
						_context2.next = 11;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](0);

						if (_context2.t0.status === 405) {
							if (_context2.t0.data.message === 'USER_HAS_ASSOCIATED_DATA') {
								this.showError('Tiene datos asociados');
							}
						} else {
							this.showError();
						}

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 8]]);
	}));

	return function deleteImplementers() {
		return _ref3.apply(this, arguments);
	};
}();

var listImplementers = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							page: 1,
							search: null
						};
						_context3.next = 3;
						return this.$http.get('implementers', { params: params });

					case 3:
						response = _context3.sent;

						this.rowsImplementers = response.data.data;

					case 5:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function listImplementers() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
	this.listImplementers();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Correo', value: 'email', checked: true, visible: true }, { id: 3, name: 'Teléfono', value: 'phone', checked: true, visible: true }, { id: 4, name: '#Compañia', value: 'numberCompany', checked: true, visible: true }, { id: 5, name: 'País', value: 'country', checked: true, visible: true }, { id: 6, name: 'Acciones', value: 'actions', checked: true, visible: true }],
		checkAll: false,
		currentPage: 1,
		dialog: false,
		dialogMessage: '',
		idDelete: null,
		lastPage: 0,
		params: {
			page: 1
		},
		rows: [],
		rowsImplementers: []
	};
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

function goToCompany(_ref2) {
	var id = _ref2.id;

	this.goTo('page-implementers-company', { params: { id: id } });
}

function goToDeatil(id) {
	this.goTo('page-implementers-create', { params: { id: id } });
}

function newRoute(newValue, afterValue) {
	if (newValue.name === 'page-config-implementers' && afterValue.name === 'page-implementers-create') {
		this.listImplementers();
	}
}

function openDialog(item) {
	this.dialogMessage = '\xBFDesea eliminar de la lista a \'' + item.name + '\'?';
	this.idDelete = item.id;
	this.dialog = true;
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.idDelete = null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'implementers-list',
	created: created,
	data: data,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		changePage: changePage,
		goToCompany: goToCompany,
		loadData: loadData,
		goToDeatil: goToDeatil,
		closeDialog: closeDialog,
		deleteImplementers: deleteImplementers,
		onSearch: onSearch,
		openDialog: openDialog,
		listImplementers: listImplementers
	},
	watch: {
		$route: newRoute
	}
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_list_configuration_vue__ = __webpack_require__(849);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd361a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_list_configuration_vue__ = __webpack_require__(1070);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_list_configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd361a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_list_configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.c32d42d87c5db57e44e2.js